// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuItem_container__2LReC","isSelected":"MenuItem_isSelected__1vmW8","children":"MenuItem_children__38tWu"};